import { ROLES } from "./Roles";
export const SideBarDropdownData = [
   {
      menuName: "Dashboard",
      url: "/dashboard",
      icon: "fa-home",
      roles: [ROLES.corporateAdmin, ROLES.manager],
      permission: "",
      isDirectLink: true,
      dropdownList: [],
   },
   {
      menuName: "User",
      url: "/user/view",
      icon: "fa-user",
      roles: [ROLES.corporateAdmin, ROLES.manager],
      permission: "users.view",
      isDirectLink: true,
      dropdownList: [],
   },

   {
      menuName: "Fleet Master",
      url: "/fleet-master",
      icon: "fa-truck",
      roles: [ROLES.corporateAdmin],
      permission: "fleets.view",
      isDirectLink: false,
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
            permission: "fleets.create",
         },
         {
            subMenuName: "View",
            url: "/list",
            subDropdownList: [],
            permission: "fleets.view",
         },
         {
            subMenuName: "Fleet Maintenance",
            path: "/fleet-maintenance",
            subDropdownList: [],
            permission: "fleets.view",
         },

         // {
         //    subMenuName: "Kilolitre Master",
         //    url: "/kiloleter-master",
         //    subDropdownList: [
         //       {
         //          subMenuName: "Add",
         //          url: "/add"
         //       },
         //       {
         //          subMenuName: "View",
         //          url: "/list"
         //       }
         //    ],
         // },

      ],
   },
  {
      menuName: "Vehicle Tracking",
      url: "/vehicle-tracking",
      icon: "fa-map-marked-alt",
      roles: [ROLES.corporateAdmin, ROLES.manager],
      permission: "",
      isDirectLink: true,
      dropdownList: [],
   },
   {
      menuName: "Driver Master",
      url: "/driver-master/view",
      icon: "fa-dharmachakra",
      roles: [ROLES.corporateAdmin],
      permission: "drivers.view",
      isDirectLink: true,
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
            permission: "drivers.create",
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
            permission: "drivers.view",
         },
         // {
         //    subMenuName: "Fleet Assignment",
         //    url: "/fleet-assignment",
         //    subDropdownList: [],
         //    permission: "drivers.create",
         // },
      ],
   },
   {
      menuName: "Payroll Master",
      url: "/payroll-master",
      icon: "fa-money-bill-wave",
      roles: [ROLES.corporateAdmin],
      permission: "payroll.view",
      isDirectLink: false,
      dropdownList: [
         {
            subMenuName: "Payroll List",
            url: "/payroll-list/view",
            subDropdownList: [],
            permission: "payroll.view",
         },
         {
            subMenuName: "Payroll Structure",
            url: "/payroll-structure/view",
            subDropdownList: [],
            permission: "payroll.view",
         },
      ],
   },
   {
      menuName: "Payroll",
      url: "/settings/payroll",
      icon: "fa-file-invoice-dollar",
      roles: [ROLES.corporateAdmin, ROLES.management],
      permission: ["payrolls.view", "attendance_summary.view", "attendance_summary.create"],
      isDirectLink: true,
      dropdownList: [],
   },
   {
      menuName: "Daily Attendance",
      url: "/settings/daily-attendance",
      icon: "fa-calendar-check",
      roles: [ROLES.corporateAdmin, ROLES.management],
      permission: "daily_attendances.view",
      isDirectLink: true,
      dropdownList: [],
   },
   {
      menuName: "Helper  Master",
      url: "/helper-master/view",
      icon: "fa-id-badge",
      roles: [ROLES.corporateAdmin],
      permission: "helpers.view",
      isDirectLink: true,
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
            permission: "helpers.create",
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
            permission: "helpers.view",
         },
      ],
   },
   {
      menuName: "Customer Master",
      url: "/customer-master/view",
      icon: "fa-user",
      roles: [ROLES.corporateAdmin],
      permission: "customers.view",
      isDirectLink: true,
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
            permission: "customers.create",
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
            permission: "customers.view",
         },
      ],
   },
   {
      menuName: "Contractor Master",
      url: "/contractor-master/view",
      icon: "fa-clipboard-list",
      roles: [ROLES.corporateAdmin],
      permission: "contractors.view",
      isDirectLink: true,
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
            permission: "contractors.create",
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
            permission: "contractors.view",
         },
      ],
   },
   // {
   //    menuName: "Vendor  Master",
   //    url: "/vendor-master",
   //    icon: "fa-tree",
   //    roles: [ROLES.corporateAdmin],
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/add-form",
   //          subDropdownList: [],
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //       },
   //    ],
   // },
   
   // {
   //    menuName: "Location Master",
   //    url: "/location-master",
   //    icon: "fa-map-marker-alt",
   //    roles: [ROLES.corporateAdmin],
   //    permission: "locations.view",
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/Add",
   //          subDropdownList: [],
   //          permission: "locations.create",
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [
   //             // {
   //             //    subMenuName: "Add",
   //             //    url: "/add",
   //             // },
   //             // {
   //             //    subMenuName: "View",
   //             //    url: "/view",
   //             // }
   //          ],
   //          permission: "locations.view",
   //       },
   //    ],
   // },
   {
      menuName: "Route Master",
      url: "/route-master/view",
      icon: "fa-road",
      roles: [ROLES.corporateAdmin],
      permission: "routes.view",
      isDirectLink: true,
      dropdownList: [
         // {
         //    subMenuName: "Add",
         //    url: "/add-form",
         //    subDropdownList: [],
         //    permission: "routes.create",
         // },
         {
            subMenuName: "Routes",
            url: "/view",
            subDropdownList: [],
            permission: "routes.view",
         },
      ],
   },

   {
      menuName: "Lane Master",
      url: "/lane-master/view",
      icon: "fa-arrows-alt-h",
      roles: [ROLES.corporateAdmin],
      permission: "lanes.view",
      isDirectLink: true,
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
            permission: "lanes.create",
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
         },
      ],
   },
   // {
   //    menuName: "Node Master",
   //    url: "/node-master",
   //    icon: "fa-map-marker-alt",
   //    roles: [ROLES.corporateAdmin],
   //    permission: "nodes.view",
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/add",
   //          subDropdownList: [],
   //          permission: "nodes.create",
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //          permission: "nodes.view",
   //       },
   //    ],
   // },

   {
      menuName: "Product Master",
      url: "/product-master/view",
      icon: "fa-box",
      roles: [ROLES.corporateAdmin],
      permission: "products.view",
      isDirectLink: true,
      dropdownList: [
         {
            subMenuName: "Products",
            url: "/view",
            subDropdownList: [],
            permission: "products.view",
         },
         // {
         //    subMenuName: "Product Category",
         //    url: "",
         //    subDropdownList: [
         //       {
         //          subMenuName: "Add",
         //          url: "/category/add-form",
         //       },
         //       {
         //          subMenuName: "View",
         //          url: "/category/view",
         //       },
         //    ],
         // },
      ],
   },

   // {
   //    menuName: "Lane Master",
   //    url: "/lane-master",
   //    icon: "fa-arrows-alt-h",
   //    roles: [ROLES.corporateAdmin],
   //    permission: "lanes.view",
   //    dropdownList: [
   //       // {
   //       //    subMenuName: "Add",
   //       //    url: "/add-form",
   //       //    subDropdownList: [],
   //       //    permission: "lanes.create",
   //       // },
   //       {
   //          subMenuName: "Lanes",
   //          url: "/view",
   //          subDropdownList: [],
   //          permission: "lanes.view",
   //       },
   //    ],
   // },
   {
      menuName: "Consignment Master",
      url: "/consignment-master/view",
      icon: "fa-box-open",
      roles: [ROLES.corporateAdmin],
      permission: "consignments.view",
      isDirectLink: true,
      dropdownList: [
         // {
         //    subMenuName: "Add",
         //    url: "/add-form",
         //    subDropdownList: [],
         //    permission: "consignments.create",
         // },
         {
            subMenuName: "Consignments",
            url: "/view",
            subDropdownList: [],
            permission: "consignments.view",
         },
      ],
   },

   // {
   //    menuName: "Part Consignment Master",
   //    url: "/part-consignment-master",
   //    icon: "fa-puzzle-piece",
   //    roles: [ROLES.corporateAdmin],
   //    permission: "part_consignments.view",
   //    dropdownList: [
   //       {
   //          subMenuName: "Create",
   //          url: "/add-form",
   //          subDropdownList: [],
   //          permission: "part_consignments.create",
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //          permission: "part_consignments.view",
   //       },
   //    ],
   // },

   // {
   //    menuName: "LR Copy",
   //    url: "/lr-copy-master",
   //    icon: "fa-copy",
   //    roles: [ROLES.corporateAdmin],
   //    permission: "lr_copies.view",
   //    dropdownList: [
   //       // {
   //       //    subMenuName: "Add",
   //       //    url: "/add-form",
   //       //    subDropdownList: [],
   //       // },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //          permission: "lr_copies.view",
   //       },
   //    ],
   // },
   {
      menuName: "Trip",
      url: "/trip/contractual/view",
      icon: "fa-truck",
      roles: [ROLES.manager],
      permission: "trips.view",
      isDirectLink:true,
      dropdownList: [
         {
            subMenuName: "Trips",
            url: "/contractual/view",
            subDropdownList: [],
            permission: "trips.view",
         },
         {
            subMenuName: "Expense Type",
            url: "/expense-type",
            subDropdownList: [
               {
                  subMenuName: "Add",
                  url: "/add",
                  permission: "trips.view",
               },
               {
                  subMenuName: "View",
                  url: "/view",
                  permission: "trips.view",
               },
            ],
         },
         // {
         //    subMenuName: "Contractual",
         //    url: "/contractual",
         //    permission: "trips.view",
         //    subDropdownList: [
         //       {
         //          subMenuName: "Add",
         //          url: "/add",
         //          permission: "trips.create",
         //       },
         //       {
         //          subMenuName: "View",
         //          url: "/view",
         //          permission: "trips.view",
         //       },
         //    ],
         // },
         // {
         //    subMenuName: "Adhoc",
         //    url: "/adhoc",
         //    subDropdownList: [
         //       {
         //          subMenuName: "View",
         //          url: "/view",
         //       },
         //    ],
         // },
      ],
   },

   // {
   //    menuName: "Company Master",
   //    url: "/company-master",
   //    icon: "fa-building",
   //    roles: [ROLES.corporateAdmin],
   //    permission: "companies.view",
   //    dropdownList: [
   //       // {
   //       //    subMenuName: "Add",
   //       //    url: "/add-form",
   //       //    subDropdownList: [],
   //       //    permission: "companies.create",
   //       // },
   //       {
   //          subMenuName: "Companies",
   //          url: "/view",
   //          subDropdownList: [],
   //          permission: "companies.view",
   //       },
   //    ],
   // },
   {
      menuName: "Reports",
      url: "/reports",
      icon: "fa-list",
      roles: [ROLES.corporateAdmin, ROLES.manager],
      permission: "reports.view",
      dropdownList: [
         {
            subMenuName: "Loading Report",
            url: "/loading-report",
            subDropdownList: [],
            permission: "reports.loading",
         },
         {
            subMenuName: "Performance Report",
            url: "/performance-report",
            subDropdownList: [],
            permission: "reports.performance",
         },
      ],
   },
   {
      menuName: "Settings",
      url: "",
      icon: "fa-cog",
      roles: [ROLES.corporateAdmin, ROLES.management],
      permission: "users.view",
      dropdownList: [
         {
            subMenuName: "Head of Accounts",
            url: "/settings/head-of-accounts",
            subDropdownList: [],
            permission: "users.view",
         },
         {
            subMenuName: "Unit Management",
            url: "/settings/units",
            subDropdownList: [],
            permission: "users.view",
         },
         {
            subMenuName: "App Config",
            url: "/settings/app-config",
            subDropdownList: [],
            permission: "users.view",
         },
         {
            subMenuName: "Product Classification",
            url: "/settings/product-classification",
            subDropdownList: [],
            permission: "users.view",
         },
         {
            subMenuName: "Product Category",
            url: "/product-master/category/view",
            subDropdownList: [],
            permission: "products.view",
         },
         {
            subMenuName: "Role",
            url: "/role-master/list",
            subDropdownList: [],
            permission: "users.view",
         },
         {
            subMenuName: "Permission",
            url: "/permission-master/list",
            subDropdownList: [],
            permission: "users.view",
         },
         {
            subMenuName: "Country",
            url: "/geo-data/country/view",
            subDropdownList: [],
            permission: "geo_data.view",
         },
         {
            subMenuName: "Zone",
            url: "/geo-data/zone/view",
            subDropdownList: [],
            permission: "geo_data.view",
         },
         {
            subMenuName: "State",
            url: "/geo-data/state/view",
            subDropdownList: [],
            permission: "geo_data.view",
         },
         {
            subMenuName: "City",
            url: "/geo-data/city/view",
            subDropdownList: [],
            permission: "geo_data.view",
         },
         {
            subMenuName: "Pincode",
            url: "/geo-data/pincode/view",
            subDropdownList: [],
            permission: "geo_data.view",
         },
         {
            subMenuName: "Tonnage",
            url: "/fleet-master/tonnage/list",
            subDropdownList: [],
         },
         {
            subMenuName: "Vehicle Category",
            url: "/fleet-master/vehicle-category/list",
            subDropdownList: [],
         },
      ],
   },

   // {
   //    menuName: "Create Adhoc Lane",
   //    url: "/adhoc-lane",
   //    icon: "fa-map-marker-alt",
   //    roles: [ROLES.management, ROLES.manager],
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/add",
   //          subDropdownList: [],
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //       },
   //    ],
   // },
   // {
   //    menuName: "Create Adhoc Vendor",
   //    url: "/adhoc-vendor",
   //    icon: "fa-map-marker-alt",
   //    roles: [ROLES.management, ROLES.manager],
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/add",
   //          subDropdownList: [],
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //       },
   //    ],
   // },
];

export const Roles = [
   // {
   //    value: 1,
   //    label: "Management",
   // },
   {
      value: 2,
      label: "Manager",
   },
];

const selectOptionData = [
   {
      label: "New/Nylon",
      value: 1,
   },
   {
      label: "New/Radial",
      value: 2,
   },
   {
      label: "Remold/Nylon",
      value: 3,
   },
   {
      label: "Remold/Radial",
      value: 4,
   },
];

export default selectOptionData;

export const fleetMasterFormTitle = [
   {
      label: "Vehicle Details",
      value: 0,
   },
   {
      label: "EMI",
      value: 1,
   },
   {
      label: "Service Record",
      value: 2,
   },
   {
      label: "Tyre",
      value: 3,
   },
   {
      label: "Monthly Maintenance Budget",
      value: 4,
   },
];

export const fleetMasterFormEdit = [
   {
      label: "Vehicle Details",
      value: 0,
   },
   // {
   //     label: "EMI",
   //     value: 1,
   // },
   {
      label: "Service Record",
      value: 1,
   },
   {
      label: "Tyre",
      value: 2,
   },
   {
      label: "Monthly Maintenance Budget",
      value: 3,
   },
];
export const locationData = [
   {
      label: "Kolkata",
      value: "Kolkata",
   },
   {
      label: "Delhi",
      value: "Delhi",
   },
   {
      label: "Patna",
      value: "Patna",
   },
];
export const originData = [
   {
      label: "Kolkata",
      value: "Kolkata",
   },
   {
      label: "Delhi",
      value: "Delhi",
   },
   {
      label: "Patna",
      value: "Patna",
   },
];
export const vehicleCategoryData = [
   {
      label: "20ft",
      value: "20ft",
   },
   {
      label: "22ft",
      value: "22ft",
   },
   {
      label: "24ft",
      value: "24ft",
   },
   {
      label: "32ft SXL",
      value: "32ft SXL",
   },
   {
      label: "32ft MXL",
      value: "32ft MXL",
   },
   {
      label: "Any Other",
      value: "Any Other",
   },
];

export const tonnageData = [
   {
      label: "5",
      value: "5",
   },
   {
      label: "6",
      value: "6",
   },
   {
      label: "7",
      value: "7",
   },
   {
      label: "8",
      value: "8",
   },
   {
      label: "9",
      value: "9",
   },
   {
      label: "10.5",
      value: "10.5",
   },
   {
      label: "15",
      value: "15",
   },
   {
      label: "18",
      value: "18",
   },
   {
      label: "any other",
      value: "any other",
   },
];

export const destinationData = [
   {
      label: "New York",
      value: "New York",
   },
   {
      label: "Paris",
      value: "Paris",
   },
   {
      label: "Tokyo",
      value: "Tokyo",
   },
   {
      label: "London",
      value: "London",
   },
];

export const makeData = [
   {
      label: "Tata",
      value: "Tata",
   },
   {
      label: "Eicher",
      value: "Eicher",
   },
   {
      label: "Ashok leyland",
      value: "Ashok leyland",
   },
];

export const customDataTableStyle = {
   table: {
      style: {
         border: "1px solid #007BFF", // Set border color
         borderRadius: "5px 5px 0 0",
      },
   },
   rows: {
      style: {
         //  minHeight: "72px", // override the row height
         border: "1px solid #007BFF",
      },
   },

   headCells: {
      style: {
         padding: "1rem ",
         backgroundColor: "#007BFF",
         color: "#fff",
         fontSize: "16px",
         fontWeight: "bold",
         marginBottom: "-1px",
      },
   },
   cells: {
      style: {
         padding: "0.2rem 1rem",
         //  borderRight: "1px solid #007BFF",
         fontSize: "14px",
      },
   },
};

export const tripTypeData = {
   tripTypeOptions: [
      { label: "Contractual", value: "contractual" },
      { label: "Adhoc", value: "adhoc" },
      { label: "Express", value: "express" },
   ],

   tripStatusOptions: [
      { label: "Open", value: "open" },
      { label: "Pending", value: "pending" },
      { label: "Closed", value: "closed" },
   ],
};
